import { render } from "./IconTrain.vue?vue&type=template&id=504b3936"
import script from "./IconTrain.vue?vue&type=script&lang=ts"
export * from "./IconTrain.vue?vue&type=script&lang=ts"
script.render = render

export default script